import { Component, OnInit } from '@angular/core';
import {ConfigService} from '../../../core/_base/services/config.service';
import {Router} from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],

})
export class HeaderComponent implements OnInit {
  outButton!: boolean;
  titeTextToolbar: string = '';
  classWidth='';

  constructor(private configS: ConfigService,
    private router: Router,
    public deviceService: DeviceDetectorService) { }

  ngOnInit(): void {
    if(this.deviceService.isDesktop()){
      this.classWidth = 'widthTitleDesktop-445';
    }
    if(this.deviceService.isTablet()){
      this.classWidth = 'widthTitleDesktop-845';
    }
    if(this.deviceService.isMobile()){
      this.classWidth = 'widthTitleDesktop-425';
    }
    this.outButton = Boolean(this.configS.getValue('BUTTON_OUT'));
    this.titeTextToolbar = this.configS.getValue('GLOBAL_TXT_TIT_APERURA');
  }

  out() {
    this.router.navigateByUrl('/iniciar/redirect');
  }

}
